/* eslint-disable import/no-anonymous-default-export */
/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, Switch, Redirect} from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "assets/plugins/helixa/css/helixa.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import "./App.css"

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

import {ConfigProvider, theme} from "antd";
import Palette from "./utils/Palette";
import RoleControlProvider from "context/RoleControlContext";

export default function (props) {

    const adminRole = localStorage.getItem('role');

    const [kicked, setKicked] = useState(false);

    useEffect(() => {
        checkToken();
    }, []);

    const logout = () => {
        localStorage.removeItem("super_token")
        localStorage.removeItem("admin_name")
        localStorage.removeItem("token")
        localStorage.removeItem("role")

        sessionStorage.removeItem("super_token")
        sessionStorage.removeItem("admin_name")
        sessionStorage.removeItem("role")
        sessionStorage.removeItem("token")

        setKicked(true);
    }

    const login = () => {
        setKicked(false);
    }

    const checkToken = () => {
        let token = localStorage.getItem('super_token') || localStorage.getItem('token');
        
        if (!token) {
            logout();
            return;
        }

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const isExpired = Date.now() >= payload.exp * 1000;
            
            if (isExpired) {
                logout();
                return;
            }

            login();
        } catch (error) {
            logout();
        }
    }

    return <div>
        <ConfigProvider
            theme={{
                cssVar: true,
                algorithm: theme.darkAlgorithm,
                token: {
                    colorPrimary: Palette.MAIN_THEME,
                    fontFamily: 'Open Sans, sans-serif',
                    colorBgContainer: "#282828",
                    zIndexPopupBase: 1073 // Z-Index modal react-bootstrap = 1072
                },
                components: {
                    Table: {
                        headerBg: '#00000',
                        borderColor: '#FFF'
                    },
                    Form: {
                        labelColor: '#FFF'
                    },
                    Input: {
                        activeBg: "#282828",
                        colorTextPlaceholder: Palette.INACTIVE_GRAY,
                    },
                    Typography: {
                        titleMarginBottom: 0,
                        lineHeight: "1em"
                    },
                    Tag: {
                        colorBgContainer: Palette.BACKGROUND_BLACK,
                    },
                    Modal: {
                        headerBg: "#161616"
                    }
                }
            }}
        >
            <RoleControlProvider initialRole={adminRole}>
                <BrowserRouter basename="/">
                    <Switch>
                        {
                            kicked ?
                                <>
                                    <Route path="*" render={(props) => <AuthLayout onLogin={login} {...props} />}/>
                                    {/*<Redirect from="*" to="/login" />*/}
                                    {/*<Route path={"*"} component={Login}/>*/}
                                    {/*<Route from="*" to="/auth/login"/>*/}
                                </>
                                :
                                <>
                                    <Route path="/" render={(props) => <AdminLayout onLogout={logout} {...props} />} />
                                    {/*<Route path={"*"} component={Dashboard}/>*/}
                                    {/*<Route from="*" to="/admin/admin"/>*/}
                                </>
                        }
                    </Switch>
                </BrowserRouter>
            </RoleControlProvider>
        </ConfigProvider>
    </div>
}


